<template>
    <div>
        <ul
            class="result-header"
            @click="IsActive = !IsActive">
            <li>{{ offers[0].AmortizationTermMonths }} Month Refinance</li>
            <li v-if="IsActive">
                Apr
            </li><li v-else>
                <label>{{ offers.lowAPROffer.Apr }}%</label><small>APR as low as</small>
            </li>
            <li v-if="IsActive">
                Payment
            </li><li v-else>
                <label>${{ paymentFilter(offers.lowAPROffer.calculatedMonthlyPayment) }}</label><small>Per Month</small>
            </li>
            <li><i :class="{'lt4-Minus': IsActive, 'lt4-Plus' : !IsActive}"></i></li>
        </ul>
        <div
            v-for="(offer, index) in offers"
            v-show="IsActive"
            :key="index">
            <loan-term-info-sub-section
                :offer="offer"
                :lender-review-rating-details="lenderReviewRatingDetails"
                :is-lender-active="offer.IsLenderActive"
                :lender-offer-details="lenderOfferDetails"
                :badges-detail="offer.BadgesDetail"
                :field-edited="fieldEdited"
            />
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import LoanTermInfoSubSection from './loan-term-info-sub-section.vue';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            LoanTermInfoSubSection,
        },
        mixins: [RateTableInfo],
        props: {
            offers: {
                default() {
                    return {};
                },
            },
            isActive: {
                default: false,
            },
            monthlyPayment: {
                default: 0,
            },
            lenderOfferDetails: {
                default() {
                    return [];
                },
            },
            lenderReviewRatingDetails: {
                default() {
                    return [];
                },
            },
            fieldEdited: {
                default: 'no',
            },
        },
        data() {
            return {
                IsActive: this.isActive,
            };
        },
        watch: {
            IsActive() {
                if (this.IsActive) {
                    if (this.offers && this.offers.length > 0) {
                        const result = [];
                        result.TrackOfferResult = this.offers;
                        result.fieldEdited = this.fieldEdited;
                        this.rateTableViewedInfo(result);
                    }
                }
            },
        },
        mounted() {
            if (this.offers.IsActive) this.IsActive = this.offers.IsActive;
            let index = 1;
            if (this.offers && this.offers.length > 0) {
                this.offers.forEach((offer) => {
                    offer.Position = index;
                    index++;
                });
            }
        },
        methods: {
            paymentFilter(figure) {
                return figure > 0 ? Accounting.formatNumber(figure) : 0;
            },
        },
    };
</script>
